/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteApiKeyInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteApiKeyMutationVariables = {|
  input: DeleteApiKeyInput
|};
export type deleteApiKeyMutationResponse = {|
  +deleteApiKey: ?{|
    +deletedApiKeyId: ?string
  |}
|};
export type deleteApiKeyMutation = {|
  variables: deleteApiKeyMutationVariables,
  response: deleteApiKeyMutationResponse,
|};
*/


/*
mutation deleteApiKeyMutation(
  $input: DeleteApiKeyInput!
) {
  deleteApiKey(input: $input) {
    deletedApiKeyId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteApiKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteApiKeyPayload",
    "kind": "LinkedField",
    "name": "deleteApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedApiKeyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation deleteApiKeyMutation(\n  $input: DeleteApiKeyInput!\n) {\n  deleteApiKey(input: $input) {\n    deletedApiKeyId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f0573a54abffb100e0719daf52521288';

module.exports = node;
